import React from "react";
import PropTypes from "prop-types";

const SuccessCodeResolver = ({ codes, children }, context) => {
  let errorMessage = null;

  if (codes?.mint_voucher) {
    codes?.mint_voucher.map((errorCode) => {
      switch (errorCode) {
        case "Invalid Code":
          errorMessage = (
            <p>{context.t("The provided voucher code is not valid")}</p>
          );
          break;
      }
    });
  } else if (codes?.bowline_relay_transaction) {
    codes?.bowline_relay_transaction.map((errorCode) => {
      switch (errorCode) {
        case "already sent, please check status":
          errorMessage = (
            <p>
              {context.t(
                "Your transaction was already sent to the blockchain. It looks like you tried to mint the same token again. Please be patient."
              )}
            </p>
          );
          break;
      }
    });
  }

  return (
    <>
      {errorMessage}
      {!errorMessage && children}
    </>
  );
};

SuccessCodeResolver.propTypes = {
  codes: PropTypes.any,
  children: PropTypes.any,
};

SuccessCodeResolver.defaultProps = {};

SuccessCodeResolver.contextTypes = {
  t: PropTypes.func,
};
export default SuccessCodeResolver;
